import React from "react";
import { IMAGES, SOCIAL } from "../data/site";

const BrandSection = () => (
  <section className="bg-bone border-y border-line" data-testid="brand-section">
    <div className="container-x py-20 md:py-28 grid grid-cols-1 md:grid-cols-12 gap-10">
      <div className="md:col-span-5">
        <div className="aspect-[4/5] border border-line overflow-hidden">
          <img
            src={IMAGES.aboutBrand}
            alt="Footballer detail"
            className="w-full h-full object-cover"
          />
        </div>
      </div>
      <div className="md:col-span-7 flex flex-col justify-center">
        <p className="overline mb-4">The Brand</p>
        <h2 className="font-display uppercase text-4xl md:text-5xl lg:text-6xl tracking-tightest font-bold leading-[0.95]">
          Premium Pitch Wear,
          <br />
          <span className="text-mute">starting from the ground up.</span>
        </h2>
        <p className="mt-6 max-w-xl text-mute leading-relaxed">
          Pritch creates football essentials for players who care about the details. Starting with
          football-specific grip socks, the brand is built around clean design, technical fit and
          matchday-ready performance.
        </p>
        <div className="mt-10 grid grid-cols-2 sm:grid-cols-4 gap-px bg-line border border-line">
          {SOCIAL.map((s) => (
            <div key={s.handle} className="bg-white p-5">
              <p className="mono text-xs text-mute">{s.role}</p>
              <p className="text-sm font-medium mt-1">{s.handle}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  </section>
);

export default BrandSection;
